import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { PropagateLoader } from "react-spinners";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../atoms/Button";
import Heading from "../atoms/Heading";
import InputField from "../atoms/InputField";

const ModalConfirm = ({ loading, onClose, onConfirm, eliminacion = false }) => {
    const [generatedCode, setGeneratedCode] = useState("");
    const [codeMatched, setCodeMatched] = useState(false);

    useEffect(() => {
        if (eliminacion) {
            const newCode = Math.random().toString(36).substring(2, 8).toUpperCase();
            setGeneratedCode(newCode);
            setCodeMatched(false);
        }
    }, [eliminacion]);

    const validate = (values) => {
        const errors = {};
        if (eliminacion && values.code !== generatedCode) {
            setCodeMatched(false);
        } else {
            setCodeMatched(true);
        }
        return errors;
    };

    const initialValues = {
        code: "",
    };

    const handleSubmit = () => {
        if (!eliminacion || codeMatched) {
            onConfirm();
        }
    };

    return (
        <AnimatePresence>
            <motion.div
                className="fixed bottom-0 left-0 h-full w-full bg-white/30 backdrop-blur-md flex justify-center items-center z-30 px-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    className="w-full sm:w-3/5 h-fit sm:h-auto border-2 border-slate-400 bg-white rounded-lg shadow-lg p-4 flex justify-around items-center flex-col text-center gap-4"
                    initial={{ scale: 0.8, opacity: 0, y: 100 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    exit={{ scale: 0.8, opacity: 0, y: 100 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                >
                    <Heading text="¿Estas seguro de realizar esta acción?" textBold size="text-4xl" color="black" />
                    <div className="w-full h-0.5 border-2 border-slate-500 my-2" />

                    {eliminacion && (
                        <div className="w-full flex flex-col space-y-4 justify-center items-center">
                            <div className="w-1/2 bg-gray-300 rounded-lg p-4 select-none"
                                onContextMenu={(e) => e.preventDefault()}
                                onCopy={(e) => e.preventDefault()}
                                onCut={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                            >
                                <p className="font-bold tracking-widest text-lg">{generatedCode}</p>
                            </div>
                            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate}>
                                {({ isSubmitting, values, handleChange }) => (
                                    <Form className="w-full md:w-1/2">
                                        <InputField
                                            name="code"
                                            label="Código de confirmación"
                                            placeholder="Ingresa el código"
                                            onChange={handleChange}
                                            value={values.code}
                                        />
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    )}
                    <div className="w-full sm:space-x-4 flex flex-col sm:flex-row justify-around items-center">
                        <Button text={loading ? <PropagateLoader color="white" /> : "Cancelar"} bgColor="red" onClick={onClose} disabled={loading} />
                        <Button
                            text={loading ? <PropagateLoader color="red" /> : "Confirmar"} bgColor="green"
                            onClick={handleSubmit} disabled={loading || (eliminacion && !codeMatched)}
                        />
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default ModalConfirm;